import { z } from 'zod';
import { CompetenciaChave, DataISO, Id } from './comum.js';

/** Que mês o pedido cobre: o anterior (em outubro pedem-se os extratos de setembro) ou o corrente. */
export const CompetenciaDoPedido = z.enum(['ANTERIOR', 'ATUAL']);
export type CompetenciaDoPedido = z.infer<typeof CompetenciaDoPedido>;

/** Regra do pedido mensal de documentos: o sistema cria a solicitação todo mês, no dia marcado. */
export const SolicitacaoRecorrenteBody = z.object({
  /** nulo = todos os clientes ativos (os novos entram sozinhos) */
  clienteId: Id.nullable().default(null),
  titulo: z.string().trim().min(2).max(200),
  descricao: z.string().trim().max(2000).nullable().default(null),
  /** 1 a 28, para existir em todo mês */
  diaDoMes: z.coerce.number().int().min(1).max(28).default(1),
  /** prazo dado ao cliente, em dias a partir da criação */
  prazoDias: z.coerce.number().int().min(0).max(60).default(5),
  competencia: CompetenciaDoPedido.default('ANTERIOR'),
  /** e-mail aos contatos que recebem avisos + push do portal */
  avisar: z.boolean().default(true),
  ativo: z.boolean().default(true),
});
export type SolicitacaoRecorrenteBody = z.infer<typeof SolicitacaoRecorrenteBody>;

export const SolicitacaoRecorrenteEditarBody = z.object({
  clienteId: Id.nullable().optional(),
  titulo: z.string().trim().min(2).max(200).optional(),
  descricao: z.string().trim().max(2000).nullable().optional(),
  diaDoMes: z.coerce.number().int().min(1).max(28).optional(),
  prazoDias: z.coerce.number().int().min(0).max(60).optional(),
  competencia: CompetenciaDoPedido.optional(),
  avisar: z.boolean().optional(),
  ativo: z.boolean().optional(),
});
export type SolicitacaoRecorrenteEditarBody = z.infer<typeof SolicitacaoRecorrenteEditarBody>;

export const SolicitacaoRecorrente = z.object({
  id: Id, clienteId: Id.nullable(), clienteNome: z.string().nullable(), titulo: z.string(), descricao: z.string().nullable(),
  diaDoMes: z.number().int(), prazoDias: z.number().int(), competencia: CompetenciaDoPedido, avisar: z.boolean(), ativo: z.boolean(),
  criadaPorApelido: z.string().nullable(), criadoEm: z.string(),
  /** a última competência já pedida e quantos pedidos a regra criou (na ficha, só os daquele cliente) */
  ultimaCompetencia: CompetenciaChave.nullable(), geradas: z.number().int(),
  /** próximo dia em que a regra cria pedidos */
  proximaEm: DataISO,
});
export type SolicitacaoRecorrente = z.infer<typeof SolicitacaoRecorrente>;

export const SolicitacaoRecorrenteQuery = z.object({ clienteId: Id.optional() });

/** Resultado de uma rodada (do worker ou do "gerar agora"). */
export const GeracaoRecorrente = z.object({ criadas: z.number().int(), clientes: z.number().int(), jaExistiam: z.number().int(), competenciaChave: CompetenciaChave });
export type GeracaoRecorrente = z.infer<typeof GeracaoRecorrente>;
